function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isEqual } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import { makeVM, resolveModel, resolveGetter, resolveSetter, parseFieldRules, isValidateField } from './utils';
import SubMixin from './mixins/sub';
export default {
  name: buildComponentName('FieldDecorator'),
  mixins: [SubMixin],
  inject: ['formItemNode'],
  props: {
    name: {
      type: String,
      default: '',
      required: true
    },
    rules: {
      type: [String, Object, Array],
      default: ''
    },
    valuePath: {
      type: String,
      default: ''
    },
    validator: {
      type: Object,
      default: null
    },
    hasFeedback: {
      type: Boolean,
      default: false
    },
    alias: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      field: null
    };
  },
  computed: {
    prefixCls: function prefixCls() {
      var rootPrefixCls = this.rootPrefixCls;
      return "".concat(rootPrefixCls, "-item");
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          name = this.name,
          hasFeedback = this.hasFeedback,
          flags = this.formValidator.flags;
      var flag = flags[name] || {};
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-decorator"), true), _defineProperty(_ref, 'has-feedback', hasFeedback || flag.pending), _defineProperty(_ref, 'has-success', !flag.pending && flag.valid), _defineProperty(_ref, 'has-error', flag.validated && flag.invalid), _defineProperty(_ref, 'is-validating', flag.pending), _ref;
    },
    fieldRules: function fieldRules() {
      var rules = this.rules;
      return rules ? this.normalizeRules(rules) : {};
    },
    ruleNames: function ruleNames() {
      return this.fieldRules.rules;
    },
    normalizeAlias: function normalizeAlias() {
      var alias = this.alias,
          formItemNode = this.formItemNode,
          name = this.name;
      return alias || formItemNode.label || name;
    }
  },
  mounted: function mounted() {
    var fieldAttach = this.fieldAttach,
        addToFormItem = this.addToFormItem,
        customWatch = this.customWatch;
    addToFormItem();
    fieldAttach();
    customWatch();
  },
  beforeDestroy: function beforeDestroy() {
    var formValidator = this.formValidator,
        field = this.field;
    this.removeFromFormItem();

    if (isValidateField(field)) {
      formValidator.detach(field);
    }
  },
  methods: {
    customWatch: function customWatch() {
      var _this = this;

      var updateField = this.updateField;
      this.$watch(function () {
        var globalValidatorOptions = _this.globalValidatorOptions,
            validatorOptions = _this.validator,
            ruleNames = _this.ruleNames,
            name = _this.name,
            valuePath = _this.valuePath,
            normalizeAlias = _this.normalizeAlias;
        return {
          globalValidatorOptions: globalValidatorOptions,
          validatorOptions: validatorOptions,
          ruleNames: ruleNames,
          name: name,
          valuePath: valuePath,
          normalizeAlias: normalizeAlias
        };
      }, function (nVal, oVal) {
        // 阻止无效更新
        if (!isEqual(nVal, oVal)) {
          updateField();
        }
      });
    },
    addToFormItem: function addToFormItem() {
      var formItemNode = this.formItemNode;
      formItemNode.addItemField(this);
    },
    removeFromFormItem: function removeFromFormItem() {
      var formItemNode = this.formItemNode;
      formItemNode.removeItemField(this);
    },
    normalizeRules: function normalizeRules(rules) {
      var r = parseFieldRules(rules);
      this.setFieldMessage(this.name, r.messages);
      return r;
    },
    buildFieldOptions: function buildFieldOptions() {
      var slotDefault = this.$slots.default,
          formRoot = this.formRoot,
          globalValidatorOptions = this.globalValidatorOptions,
          validatorOptions = this.validator,
          name = this.name,
          ruleNames = this.ruleNames,
          valuePath = this.valuePath,
          normalizeAlias = this.normalizeAlias;
      var vnode = null;

      if (slotDefault) {
        var _slotDefault$filter = slotDefault.filter(function (v) {
          return v.context && v.data;
        });

        var _slotDefault$filter2 = _slicedToArray(_slotDefault$filter, 1);

        vnode = _slotDefault$filter2[0];
      }

      var options = null;

      if (vnode) {
        var model = resolveModel(vnode);
        var el = vnode.elm;
        var customValidatorOptions = validatorOptions || {};
        var getter = resolveGetter(el, vnode, model, valuePath);
        var setter = resolveSetter(name, el, vnode, model, valuePath);

        if (ruleNames) {
          var listen = true;
          [globalValidatorOptions, customValidatorOptions].forEach(function (v) {
            if ('disable' in v) {
              listen = !v.disable;
            }
          });
          options = _objectSpread({}, globalValidatorOptions, {}, customValidatorOptions, {
            listen: listen,
            rules: ruleNames,
            expression: ruleNames,
            alias: normalizeAlias
          }); // Validator.isTargetRule 规则, 使用 alias

          if (el && el.setAttribute) {
            el.setAttribute('data-vv-as', normalizeAlias);
          }
        }

        options = _objectSpread({}, options, {
          name: name,
          el: el,
          component: vnode.componentInstance,
          vm: makeVM(formRoot, vnode.context),
          model: model,
          getter: getter,
          $$setter: setter,
          initialValue: getter()
        });
      }

      return options;
    },
    fieldAttach: function fieldAttach() {
      var formValidator = this.formValidator,
          buildFieldOptions = this.buildFieldOptions;
      var options = buildFieldOptions();

      if (options) {
        options.vm.$refs["".concat(options.name, "Ref")] = options.component;
      }

      if (isValidateField(options)) {
        var field = formValidator.attach(options);
        field.$$setter = options.$$setter;
        this.field = field;
      } else {
        // 两种情况 1. 文本节点= null, 2. 无验证rule的普通节点
        this.field = options;
      }
    },
    updateField: function updateField() {
      var field = this.field,
          buildFieldOptions = this.buildFieldOptions;

      if (isValidateField(field)) {
        var options = buildFieldOptions();
        field.update(options);
      }
    },
    onEnter: function onEnter(errorMsg) {
      this.formItemNode.setHasError(!!errorMsg);
    },
    onLeave: function onLeave() {
      this.formItemNode.setHasError(false);
    },
    getErrorMsg: function getErrorMsg() {
      var errors = this.formValidator.errors,
          name = this.name;

      if (errors.has(name)) {
        return errors.first(name);
      }

      return null;
    },
    renderHelp: function renderHelp() {
      var h = this.$createElement;
      var rootPrefixCls = this.rootPrefixCls,
          getErrorMsg = this.getErrorMsg,
          onEnter = this.onEnter,
          onLeave = this.onLeave;
      var errorMsg = getErrorMsg();
      var errorElement = errorMsg ? h("div", {
        "class": "".concat(rootPrefixCls, "-explain")
      }, [errorMsg]) : null;
      return h("transition", {
        "attrs": {
          "name": "show-help"
        },
        "on": {
          "enter": function enter() {
            onEnter(errorMsg);
          },
          "after-leave": function afterLeave() {
            onLeave(errorMsg);
          }
        }
      }, [errorElement]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var _this$$slots = this.$slots,
        slotDefault = _this$$slots.default,
        slotSuffix = _this$$slots.suffix,
        prefixCls = this.prefixCls,
        classes = this.classes,
        renderHelp = this.renderHelp;
    return h("span", {
      "class": classes
    }, [h("span", {
      "class": "".concat(prefixCls, "-children")
    }, [slotDefault, slotSuffix]), renderHelp()]);
  }
};